export const CheckListTypes = {
    GET_CHECKLIST: "GET_CHECKLIST",
    CLEAR_CHECKLIST: "CLEAR_CHECKLIST",
    GET_CHECKLIST_REPORT: "GET_CHECKLIST_REPORT",
    CLEAR_CHECKLIST_REPORT: "CLEAR_CHECKLIST_REPORT",
}